// extracted by mini-css-extract-plugin
export default {"background":"styles_background__CCJoY","box":"styles_box__wfE7r","textarea":"styles_textarea__7FFPM","input":"styles_input__iG1PV"};